import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { ControlProps } from "../../../controls/control";
import { FormGroup, FormGroupProps, FormGroupType } from "./formGroup";

interface FormInputProps extends ControlProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
}

const ComponentProps = (props: FormInputProps): ControlProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormInputProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormInput: React.FC<ControlProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlInput {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};